/**
 * Converts a snake_case string to Title Case
 * @param text Snake_case string to format
 * @returns Title Case string
 */
export const formatSnakeCase = (text: string): string => {
  return text
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
